import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function Terms() {
  return (
    <LegalPage
      testid="terms-page"
      eyebrow="Legal"
      title="Terms of Service"
      sections={[
        { h: "Use of this site", p: "By accessing this website you agree to use it lawfully and respectfully. All music, artwork, and brand assets are the property of Heart N Soul Records and P. Frazy." },
        { h: "Purchases", p: "Merch orders are subject to availability and confirmation of payment at checkout. Prices are listed in USD." },
        { h: "Intellectual property", p: "You may not reproduce, distribute, or use any content from this site without prior written permission." },
        { h: "Changes", p: "We may update these terms from time to time. Continued use of the site constitutes acceptance of the current terms." },
      ]}
    />
  );
}
